import { render, staticRenderFns } from "./ConfirmOTP.vue?vue&type=template&id=5ddefbe4&scoped=true"
import script from "./ConfirmOTP.vue?vue&type=script&lang=js"
export * from "./ConfirmOTP.vue?vue&type=script&lang=js"
import style0 from "./ConfirmOTP.vue?vue&type=style&index=0&id=5ddefbe4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddefbe4",
  null
  
)

export default component.exports